/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Omit<Event, \'id\'>, schemaOptions: { title: \'NewEvent\', exclude: [ \'id\' ] })
 */
export interface NewEvent { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    name: string;
    description?: string;
    dateStart: string;
    dateEnd?: string;
    publish?: boolean;
    frequency?: string;
    url?: string;
    typeEventId?: string;
}

